import { CSSObject, Theme } from '@mui/material'

import { ChipColor } from 'components/Chips/StatusChip/types'
import { BuildOrderStatus } from 'features/history/pages/BuildsPage/types'

export const chipColors: ChipColor<BuildOrderStatus> = (
  theme: Theme,
  status: BuildOrderStatus,
): CSSObject['backgroundColor'] => {
  switch (status) {
    case 'completed':
      return theme.palette.success.main
    case 'failed':
      return theme.palette.error.main
    case 'inProgress':
      return theme.palette.warning.main
  }
}
